import * as Models from "../../../Models";
import * as Services from "../../../Services";

export interface ICreditCheckNameInequalityScope extends ng.IScope {
    creditCheckNameInequalityCtrl: CreditCheckNameInequalityController;
    creditCheckNameEqualityRecord: Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord;
    igsCustomerNumber: string;
}

export class CreditCheckNameInequalityController implements ng.IDirective {
    private showLogging: boolean = false;
    public restrict = "E";
    public scope = {
        creditCheckNameEqualityRecord: "=",
        igsCustomerNumber: "="
    };

    public template = require("./creditCheckNameInequality.html");
    public creditCheckNameEqualityRecord: Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord;
    public igsCustomerNumber: string;
    public $scope: ICreditCheckNameInequalityScope;
    public $state: angular.ui.IStateService;
    public static $inject = ['$state', 'CreditCheckApiClient'];
    constructor(
        $state: angular.ui.IStateService,
        readonly creditCheckApiClient: Services.CreditCheckApiClient.ICreditCheckApiClient
        ) {
        this.$state = $state;
    }

    public link = ($scope: ICreditCheckNameInequalityScope): void => {
        this.$scope = $scope;
        $scope.creditCheckNameInequalityCtrl = this;

        this.$scope.creditCheckNameEqualityRecord.returnedFirstName = this.capitalizeName(this.$scope.creditCheckNameEqualityRecord.returnedFirstName);
        this.$scope.creditCheckNameEqualityRecord.returnedLastName = this.capitalizeName(this.$scope.creditCheckNameEqualityRecord.returnedLastName);
        this.$scope.creditCheckNameEqualityRecord.returnedGeneration = this.capitalizeName(this.$scope.creditCheckNameEqualityRecord.returnedGeneration);
    };

    public cancelForInequality = () => {
        this.$state.go("main.customerv2", {
            igsCustomerNumber: this.$scope.igsCustomerNumber
        });
    }

    public approveInequality = () => {
        this.creditCheckApiClient.approveCustomerCreditCheckNameEqualityRecord(this.$scope.igsCustomerNumber).then((response: Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord) => {
            this.$scope.creditCheckNameEqualityRecord = response;
        });
    }
    
    private capitalizeName = (name: string): string => {
        return name.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
    }
}